import BossModel from "@/models/BossModel";
import File from '@/models/File/File';
import Proposal from '@/models/Proposal/Proposal';
import { saveAs } from 'file-saver';

export default class DebitInvoice extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/debit-invoice';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalDebitInvoice';

    static fields() {
        return {
            id: this.attr(null),
            proposal_id: this.attr(null),
            file_id: this.attr(null),
            is_send_to_customer: this.attr(null),
            afas_job_in_progress: this.attr(null),
            is_processed_afas: this.attr(null),
            cleared_afas_commitments: this.attr(null),
            created_afas_financial_entries: this.attr(null),
            total_price: this.attr(null),
            invoice_number: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            file: this.belongsTo(File, 'file_id'),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
        }
    }

    /**
     *
     */
    loadFile() {
        File.api().find(this.file_id);
    }

    /**
     *
     * @returns {boolean|*}
     */
    File() {
        return this.getRelated('file');
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    resend() {
        return this.constructor.api().action(this.id + '/send-changed').update();
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    resendAfas(){
        return this.constructor.api().action(this.id + '/resend-debit-afas').update();
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    regenerate() {
        return this.constructor.api().action(this.id + '/regenerate').update();
    }

    /**
     *
     * @param proposalId
     * @returns {Promise<AxiosResponse<T>>}
     */
    static proposalPreview(proposalId) {
        return this.api().action(proposalId + '/preview').getBlob().then(response => {
            return saveAs(response, 'voorbeeld-factuur-'+proposalId+'.pdf');
        });
    }

    /**
     *
     * @param proposalId
     * @returns {Promise<T>}
     */
    static loadByProposal(proposalId) {
        return this.api()
            .where('proposal_id', proposalId)
            .with(['file'])
            .limit(0)
            .first()
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .with(['file', 'proposal'])
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    Proposal() {
        return this.getRelated('proposal');
    }
}
